export default "__VITE_ASSET__BIO7y2fD__"